import { Box, ButtonProps, DropButton, DropButtonExtendedProps, DropButtonProps, Text } from 'grommet'
import { FormDown } from 'grommet-icons'
import React, { CSSProperties, ReactNode, useState } from 'react'

export interface DropdownOption extends Partial<DropButtonProps & ButtonProps> {
  label: string
  handleClick?: (arg: () => void) => void
  icon?: React.ReactElement
  activeBtn?: boolean
  isDropdown?: boolean
  reverse?: boolean
  style?: CSSProperties
}

interface DropdownBtnProps extends Omit<DropButtonExtendedProps, 'dropContent' | 'label' | 'icon'> {
  options: DropdownOption[]
  dropdownLabel: string | ReactNode
  dropdownTitle?: string
  dropdownIcon?: React.ReactElement
}

export const DropdownBtn: React.FC<DropdownBtnProps> = ({
  options,
  dropdownLabel,
  dropdownTitle,
  dropdownIcon,
  ...props
}) => {
  const [open, setOpen] = useState<boolean>()
  const onOpen = () => {
    setOpen(true)
  }
  const onClose = () => {
    setOpen(false)
  }
  return (
    <DropButton
      alignSelf="center"
      dropContent={
        <Box gap={'2px'} pad={{ horizontal: '4px' }}>
          {dropdownTitle && (
            <Text color={'#333333'} size="16px" weight={300}>
              {dropdownTitle}
            </Text>
          )}
          {options?.map((option: DropdownOption, index) =>
            option.isDropdown ? (
              <DropButton
                dropContent={
                  <Box>
                    <Text>hi</Text>
                    <Text>hi</Text>
                  </Box>
                }
                dropProps={{
                  align: { left: 'right', top: 'top' },
                  margin: { left: '14px' }
                }}
                focusIndicator={true}
                icon={<FormDown />}
                justify="between"
                key={index}
                label="Actions"
                reverse={option.reverse}
                style={{ borderRadius: '4px' }}
              />
            ) : (
              <div
                className={`
                  rounded-[4px] px-1.5 py-1
                  flex items-center justify-between
                  cursor-pointer text-sm
                  transition-colors duration-200 ease-in-out
                  ${option.activeBtn ? 'bg-[#DFDAFE] hover:bg-[#DFDAFE] hover:text-[#333333]' : 'bg-transparent hover:bg-[#F5F5F5] hover:text-[#999999]'}
                  ${option.reverse ? 'flex-row-reverse' : 'flex-row'}
                `}
                key={index}
                onClick={() => {
                  option.handleClick && option.handleClick(onClose)
                }}
                style={option.style}
              >
                <span className="text-sm">{option.label}</span>
                {option.icon && (
                  <span className={`flex items-center ${option.reverse ? 'mr-2' : 'ml-2'}`}>{option.icon}</span>
                )}
              </div>
            )
          )}
        </Box>
      }
      dropProps={{
        align: { top: 'bottom' },
        margin: { left: '12px' },
        pad: { vertical: '2px' },
        round: '8px',
        stretch: true,
        style: { minWidth: '120px' }
      }}
      icon={dropdownIcon}
      label={
        <Text size="14px" weight={'normal'}>
          {dropdownLabel}
        </Text>
      }
      onClose={onClose}
      onOpen={onOpen}
      open={open}
      {...props}
    />
  )
}

export * from './DropMenu'
